<rid-word-building
  class="h-dvh"
  [assignments]="[
    {
      root: 'loop',
      words: [
        [undefined, 'loop', 't'],
        ['ge', 'lop', 'en'],
        [undefined, 'lop', 'en'],
      ],
    },
    {
      root: 'werk',
      words: [
        [undefined, 'werk', 'zaam'],
        [undefined, 'werk', 'en'],
        [undefined, 'werk', 't'],
        ['ver', 'werk', undefined],
        ['ver', 'werk', 'en'],
        ['ver', 'werk', 't'],
        ['t', 'werk', 'en'],
      ],
    },
  ]"
  (finished)="$router.navigate(['/mechanics/morphemes'])"
/>
